import { trackEvent2 } from '@shared/statistics';

export function trackOpenBankMessageDetail(messageId: string, read: boolean): void {
    trackEvent2('bankMessages', 'bankMessageDetailOpened', { messageId, read });
}

export function trackOpenBankMessages(): void {
    trackEvent2('bankMessages', 'bankMessagesOpened');
}

export function trackBankMessageAttachmentSelected(messageId: string, attachmentId: string): void {
    trackEvent2('bankMessages', 'bankMessageAttachmentSelected', { messageId, attachmentId });
}

export const trackAllBankMessagesMarkedAsRead = (): void => {
    trackEvent2('bankMessages', 'allBankMessagesMarkedAsRead');
};
